export default __webpack_public_path__ + "static/media/438.a1b2a959.png";